// src/redux/store.js
import { configureStore} from '@reduxjs/toolkit';
import menuStateReducer from './slice/menuStateSlice';


const store = configureStore({
  reducer: {
    menuState: menuStateReducer,
  },
});

export default store;

